import { IExpression } from "./IExpression";

export type VarExpression = IExpression & {
  Value: string[];
};

export const VarExpressionType = "Var";




